var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoomMapOut = function SvgZoomMapOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H17L18.5 5.5L20 7V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17L18.5 18.5L17 20H20V17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20L5.5 18.5L4 17V20H7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7L5.5 5.5L7 4H4V7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4 3.40002H8.44853L6.34853 5.50002L9.42427 8.57576L8.57574 9.42429L5.5 6.34855L3.4 8.44855V3.40002ZM4.6 4.60002V5.5515L5.55147 4.60002H4.6ZM15.5515 3.40002H20.6V8.44855L18.5 6.34855L15.4243 9.42429L14.5757 8.57576L17.6515 5.50002L15.5515 3.40002ZM18.4485 4.60002L19.4 5.5515V4.60002H18.4485ZM5.5 17.6515L8.57574 14.5758L9.42427 15.4243L6.34853 18.5L8.44853 20.6H3.4V15.5515L5.5 17.6515ZM17.6515 18.5L14.5757 15.4243L15.4243 14.5758L18.5 17.6515L20.6 15.5515V20.6H15.5515L17.6515 18.5ZM4.6 18.4486V19.4H5.55147L4.6 18.4486ZM19.4 18.4486L18.4485 19.4H19.4V18.4486Z"
  })));
};
export default SvgZoomMapOut;